import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

const CustomAttachmentSchema = z.object({
  filename: z.string().min(1),
  contentBase64: z.string().min(1),
  contentType: z.string().min(1),
});

const SendTestEmailRequestSchema = z.object({
  toEmail: z.string().email(),
  template: z.enum([
    'WELCOME',
    'SIGNIN_MAGIC_LINK',
    'USER_INVITE',
    'SUPERBILL',
  ]),
  includeTestAttachment: z.boolean().optional(),
  customAttachment: CustomAttachmentSchema.optional(),
});

const SendTestEmailResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  provider: z.string(),
  messageId: z.string().optional(),
});

export const adminTestEmailContract = c.router(
  {
    sendTestEmail: {
      method: 'POST',
      path: '/send',
      responses: {
        200: SendTestEmailResponseSchema,
      },
      body: SendTestEmailRequestSchema,
      summary: 'Send a test email to verify email delivery is working',
    },
  },
  {
    pathPrefix: '/admin/test-email',
  },
);
